import { useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'
import { BsFillTelephoneXFill } from 'react-icons/bs'
import { BiDialpadAlt } from 'react-icons/bi'
import { FaMicrophoneSlash } from 'react-icons/fa'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  endCall,
  muteMicrophoneToggle,
  isMuted,
  callHistory,
} from '../../socket/services/call'
import { getAvatar } from '../../utils/avatar'
import constants from '../../utils/constants'
import routes from '../../routes/routes'

const TIME_ACCEPTED_CALL = 10;

export function OngoingCallPage() {
  const navigate = useNavigate()
  const { state } = useLocation()
  const [number, setNumber] = useState(state.number)
  const [timer, setTimer] = useState(state.timer)
  const [isMute, setIsMute] = useState(false)
  const callTimer = useRef(timer);
  const callPhone = useRef(number);

  const handleCallCancel = () => {
    endCall()
    navigate(routes.ContactList.path, { replace: true })
  }

  const handleModalDialerOnCall = () => {
    navigate(routes.DialerOnCallPage.path, { replace: true, state: {number, timer} })
  }

  useEffect(() => {
    callPhone.current = state.number
    setNumber(state.number)
  }, [state.number])

  useEffect(() => {
    window.addEventListener('callEnded', () => {
      if (callTimer.current < TIME_ACCEPTED_CALL) callHistory(callPhone.current, callTimer.current, false)
      else callHistory(callPhone.current, callTimer.current, true)
      navigate(routes.ContactList.path, { replace: true })
    })
  }, [])

  useEffect(() => {
    callTimer.current = timer + 1
    setTimeout(() => setTimer(timer + 1), 1000)
  }, [timer])

  const formatTimer = () => getTimeFromDatetime(getTimerISOFormat())

  const getTimerISOFormat = () => new Date(timer * constants.SECONDS_IN_MILLISECONDS).toISOString()

  const getTimeFromDatetime = timer => {
    const START_POSITION_FORMAT = 11
    const END_POSITION_FORMAT = 19

    return timer.slice(START_POSITION_FORMAT, END_POSITION_FORMAT)
  }

  const handleMute = () => {
    muteMicrophoneToggle()

    setIsMute(isMuted)
  }

  return (
    <main className={styles.mainWrapper}>
      <div className={styles.information}>
        <p></p>
        <div className={styles.avatar}>
          <img
            src={getAvatar(number)}
            className={styles.avatarImage}></img>
        </div>
        <div className={styles.userInfo}>
          <p className={styles.name}>{formatTimer()}</p>
          <p className={styles.number}>{number}</p>
        </div>
      </div>
      <hr />
      <div className={styles.buttons}>
        <div
          className={styles.dialNumber + ' ' + styles.actionIcon}
          onClick={handleModalDialerOnCall}>
          <div className={styles.number}>
            <BiDialpadAlt />
          </div>
        </div>
        <div
          className={styles.dialNumber + ' ' + styles.callButton}
          onClick={handleCallCancel}>
          <div className={styles.number}>
            <BsFillTelephoneXFill />
          </div>
        </div>
        <div
          className={`${styles.dialNumber} ${styles.actionIcon} ${
            isMute ? styles.muted : ''
          }`}
          onClick={handleMute}>
          <div className={styles.number} style={{ fontSize: '25px' }}>
            <FaMicrophoneSlash />
          </div>
        </div>
      </div>
    </main>
  )
}
